export default __webpack_public_path__ + "static/web-logo-for-social-media-63f1aef432d1ba84296435816115300b.jpg";